import React, { useState, useEffect } from 'react';
import { AuthContext } from './AuthContext';
import { getToken, removeToken } from './authHelpers';
import { apiUrl } from './networkOnDemand';

const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const authToken = getToken();

    const fetchLoggedInUser = async (token) => {
      setIsLoading(true);

      try {
        const response = await fetch(`${apiUrl}/users/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (!response.ok) {
          removeToken();
          setCurrentUser(null);
          setIsLoggedIn(false);
          return;
        }

        const data = await response.json();
        setCurrentUser(data);
        setIsLoggedIn(true);
      } catch (error) {
        removeToken();
        setCurrentUser(null);
        setIsLoggedIn(false);
      } finally {
        setIsLoading(false);
      }
    };

    if (authToken) {
      fetchLoggedInUser(authToken);
    } else {
      setIsLoggedIn(false);
      setIsLoading(false);
    }
  }, []);

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        isLoggedIn,
        isLoading,
        setIsLoggedIn
      }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
